import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FilteringBy from "./components/FilteringBy";
import PostList from "./components/PostList";
import Search from "./components/Search";
import initialPosts from "./data/initialPosts";
import { loadFilteredPost } from "./redux/filter/actions";
import { loadPost } from "./redux/posts/actions";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
      dispatch(loadPost(initialPosts));
      dispatch(loadFilteredPost(initialPosts));
    }, 1000);
    return () => {};
  }, [dispatch]);

  return (
    <div>
      <Search />

      <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-white h-1/3 sm:h-2/3"></div>
        </div>
        <div className="relative max-w-7xl mx-auto">
          <div className="text-center">
            <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
              ALL BLOGS ARE HERE
            </h2>
            <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
              libero labore natus atque, ducimus sed.
            </p>
          </div>
          <FilteringBy />

          {/* <!-- card grid  --> */}
          {loading ? <h1 style={{fontSize: 48, padding: 16, textAlign: "center"}}>Loading...</h1> : <PostList />}
        </div>
      </section>
      <section className="pt-6">
        <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex justify-between gap-2 border-t text-sm text-slate-400">
          <div>Copyright 2022 Learn with Sumit.</div>
          <div>
            <a
              href="https://youtube.com/learnwithsumit"
              target="_blank"
              rel="noreferrer"
            >
              YouTube Channel
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
